import { __rest } from "tslib";
import React from 'react';
import { createTheme, StylesProvider, createGenerateClassName, ThemeProvider as MuiThemeProvider, } from '@material-ui/core';
import { chameleonDarkTheme, chameleonLightTheme } from './../../';
export const ThemeProvider = (_a) => {
    var { children, theme, skin, classNamePrefix = 'cham' } = _a, otherProps = __rest(_a, ["children", "theme", "skin", "classNamePrefix"]);
    const isDarkMode = theme === 'dark';
    // Prepend material-ui classes with a unique prefix
    const generateClassName = createGenerateClassName({
        seed: classNamePrefix,
    });
    // Setting the prefix globally
    // @ts-ignore
    window.CLASSNAME_PREFIX = classNamePrefix;
    const chameleonTheme = Object.assign({}, createTheme(isDarkMode ? chameleonDarkTheme.get(skin || 'goto') : chameleonLightTheme.get(skin || 'goto')));
    return (React.createElement(StylesProvider, Object.assign({ generateClassName: generateClassName }, otherProps),
        React.createElement(MuiThemeProvider, { theme: chameleonTheme }, children)));
};
